import { SxProps, Theme } from '@mui/material';

const styles = {
  allowanceContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  allowanceValue: {
    mt: '4px',
    fontSize: 12,
  },

  contractValueNote: {
    fontSize: 16,
    fontWeight: '600',
    color: 'grey.800',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
